import app from '@src/helpers/app';
import {RequireAtLeastOne} from '@src/@types/RequireAtLeastOne';
import getUri from '@src/helpers/getUri';

type BaseParams = {
    url: string,
    uriItems: Parameters<typeof getUri> | Parameters<typeof getUri>[number],
    searchParams?: URLSearchParams | Record<string, string | number | boolean>,
    hash?: string,
    disableFilteringForListUniqueName?: string | null,
};

type Params = RequireAtLeastOne<BaseParams, 'url' | 'uriItems'>;

export default function makeUrl(params: Params) {
    const {disableFilteringForListUniqueName = '', hash, uriItems} = params;
    let {url = '', searchParams} = params;

    if (uriItems) {
        url ||= Array.isArray(uriItems) ? getUri(...uriItems) : getUri(uriItems);
    }

    if (searchParams && !(searchParams instanceof URLSearchParams)) {
        searchParams = new URLSearchParams(
            Object.keys(searchParams).reduce<Record<string, string>>((res, key) => {
                res[key] = String((searchParams as any)[key]);

                return res;
            }, {})
        );
    }

    if (disableFilteringForListUniqueName != null) {
        searchParams ??= new URLSearchParams();
        searchParams.append(
            app('names-resolver')
                .listNames
                .getDisableFilteringGetParamNameByListUniqueName(disableFilteringForListUniqueName),
            'true'
        );
    }

    if (searchParams) {
        url += (url.includes('?') ? '&' : '?') + searchParams.toString();
    }

    if (hash) {
        url += '#' + hash.replace('#', '');
    }

    return url;
}
